import { render, staticRenderFns } from "./MatchFieldsHeader.vue?vue&type=template&id=321f1e9f&"
import script from "./MatchFieldsHeader.vue?vue&type=script&lang=ts&"
export * from "./MatchFieldsHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports